const comments = [
  {
    name: '老用户阿强',
    text: '从探花系列刚上线就在用了，探花官网入口稳定可靠，探花最新地址更新也很及时。每次打不开的时候来这个发布页就能找到新入口，从来没走丢过。探花精选合集的质量也是一直在线的。',
    date: '3天前',
  },
  {
    name: '资源收藏家',
    text: '探花在线的资源分类做得越来越好了，探花地址维护团队的效率真的高。稀有珍藏区是我的最爱，淘到了不少以前没见过的内容。建议新用户直接去看探花精选推荐，省时间。',
    date: '5天前',
  },
  {
    name: '日常打卡用户',
    text: '每天都会来探花官网看看有没有探花新地址更新。精品探花的内容筛选很用心，不会觉得内容重复。收藏夹已经存了两百多个探花入口了，推荐给朋友都说好用。',
    date: '1周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="scroll-mt-16 py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
            用户反馈
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
            {comments.map((comment) => (
              <div
                key={comment.name}
                className="bg-background-50 rounded-lg border border-background-200/60 p-5"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-line text-primary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800">{comment.name}</p>
                    <p className="text-xs text-foreground-400">{comment.date}</p>
                  </div>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{comment.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}